import {BaseEffect} from './base.effect';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {Router} from '@angular/router';
import {debug} from '../../../rxjs-operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {Product} from '../models/product';
import {error} from '..';
import {L10nTranslationService} from 'angular-l10n';
import {LoadServicesFailAction, LoadServicesSuccessAction, servicesActionTypes} from '../actions/service';
import {ServicesService} from '../services/services.service';
import {of} from 'rxjs';
import {ApiCacheService} from '../services/cache.service';

@Injectable()
export class ServicesEffect extends BaseEffect {


  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(servicesActionTypes.LOAD),
      debug('Services load action received.'),
      switchMap(() => {
        const cacheKey = 'services';
        const cached = this.apiCacheService.get<Product[]>(cacheKey); // assuming Product[] is correct type

        if (cached) {
          return of(new LoadServicesSuccessAction(cached));
        }

        return this.servicesService.getList().pipe(
          map((payload: SendBackResult<ArrayResponse<Product>>) => {
            const services = payload.data.array;
            this.apiCacheService.set(cacheKey, services);
            return new LoadServicesSuccessAction(services);
          }),
          catchError(res => this.catchResponseError(res))
        );
      })
    );
  });

  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(servicesActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving Services list.'),
    map((action: LoadServicesFailAction) =>
      error(this.translation.translate('Services_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE')))
  ) });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private servicesService: ServicesService,
              private apiCacheService: ApiCacheService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadServicesFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadServicesFailAction(response['error'].message);
  }
}
